import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "i18n";

// import { setCapacityPlaningListPaginationPage } from "actions";

import { ICONS } from "../Common/Icons";
// import TTPPaginator from "../Common/TTPPaginator";
import PageHeader from "../Common/PageHeader/PageHeader";

import CapacityPlaningList from "./CapacityPlaningList";
import CapacityPlaningProductionFilter from "./CapacityPlaningProductionFilter";

import styles from "./CapacityPlaning.local.scss";
import {
  fetchCapacityPlaningProduction,
  fetchNonCategorizedTaskTypeCount
} from "Thunks";

import {
  setCapacityPlaningProductionDate,
  setCapacityPlaningProductionYear
} from "Actions";
import { YEARS_VALUES } from "Config";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class CapacityPlaningProduction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      filterFormIsVisible: false,
      yearDivIsVisible: false
    };
  }

  componentDidMount() {
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  handleDisplayYearSelectItems = () => {
    this.setState(state => {
      return {
        yearDivIsVisible: !state.yearDivIsVisible
      };
    });
  };

  handleSelectYear = year => {
    const { dispatch } = this.props;
    this.setState({ yearDivIsVisible: false });
    dispatch(setCapacityPlaningProductionYear(year));
    dispatch(
      setCapacityPlaningProductionDate(new Date(year + "-01-01T12:00:00Z"))
    );
    dispatch(fetchCapacityPlaningProduction());
    dispatch(fetchNonCategorizedTaskTypeCount());
  };

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ yearDivIsVisible: false });
    }
  }

  renderYearSelect = () => {
    const { yearDivIsVisible } = this.state;
    const { year } = this.props;
    return (
      <div
        ref={this.setWrapperRef.bind(this)}
        className={
          styles.customed_select_year +
          " " +
          (this.state.yearDivIsVisible
            ? styles.customed_select_year_opened
            : "")
        }
      >
        <div className={styles.customed_select_year_header}>
          <span>{year}</span>
          <div className={styles.actions_year}>
            <div>
              <span
                className={styles.action_year}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i className={"icon icon-arrow-down"} />
              </span>
            </div>
          </div>
        </div>
        {yearDivIsVisible && (
          <div className={styles.customed_select_year_body}>
            <div className={styles.customed_select_year_body_options}>
              {YEARS_VALUES.map((item, index) => (
                <div
                  key={index}
                  className={styles.customed_select_year_body_option}
                  onClick={() => this.handleSelectYear(item)}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  renderErrorText = code => {
    switch (code) {
      case 170020:
      case 170021:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incorrectFile")
            }}
          />
        );
      case 170030:
        return (
          <span
            dangerouslySetInnerHTML={{
              __html: _("incompatibleModel")
            }}
          />
        );

      default:
        return <span>{_("errorOccured")}</span>;
    }
  };

  // renderPaginate() {
  //   let { items } = this.props;
  //   if (items.error != null && items.error.code === 404) {
  //     return "";
  //   }
  //   return (
  //     <TTPPaginator
  //       onPageChange={this.handleOrganizationListPageChange}
  //       pageSize={10}
  //       nbResult={20}
  //       paginationPage={1}
  //     />
  //   );
  // }

  // handleOrganizationListPageChange = ({ selected }) => {
  //   this.props.dispatch(setCapacityPlaningListPaginationPage(selected + 1));
  // };

  handleFilterFormIsVisible = isVisible => {
    this.setState({ filterFormIsVisible: isVisible });
  };

  render() {
    const { fetching, items, erpData } = this.props;
    // const { filterFormIsVisible } = this.state;

    return (
      <div>
        {inIframe() === false && (
          <div style={{ marginBottom: "10px" }}>
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <PageHeader
          header={_("productionCapacityPlanning")}
          subHeader={_("subTitleCapacityPlanningProduction")}
          icon={ICONS.STATISTICS}
        />
        <div className="rmodal__center medium-11">
          <CapacityPlaningProductionFilter
            filterFormIsVisible={this.handleFilterFormIsVisible}
            customAddOn={this.renderYearSelect()}
          />
          {/***************  capacityPlanning viewer body *************/}
          <div className={styles.container}>
            {fetching ? (
              <div className={styles.ripple_loading}>
                <img src={"/img/Ripple-1s-150px.svg"} alt="" />
              </div>
            ) : (
              <CapacityPlaningList items={items} erpData={erpData} />
            )}
          </div>
        </div>
        {/* <div
          className={`row align-center margin-bottom-2 ${filterFormIsVisible &&
            "add-margin-left"}`}
        >
          <div
            className={
              filterFormIsVisible ? "column medium-12" : "column medium-11"
            }
          >
            {fetched && items.length ? (
              this.renderPaginate()
            ) : (
              <div className="row pagination" />
            )}
          </div>
        </div> */}
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  fetching: state.capacityPlaning.production.fetching,
  fetched: state.capacityPlaning.production.fetched,
  items: state.capacityPlaning.production.data,
  year: state.capacityPlaning.production.year,
  erpData: state.erpData.data,
  filter: state.capacityPlaning.production.filter
});

export default connect(mapStateToProps)(CapacityPlaningProduction);



// WEBPACK FOOTER //
// ./src/components/CapacityPlanning/CapacityPlaningProduction.js